export const heroSlides = [
  {
    id: "m-1",
    title: "星际拾荒者",
    tag: "科幻 · 电影",
    rating: 8.6,
    meta: "2025 · 欧美 · 科幻 / 冒险",
    description:
      "一艘废弃采矿船的残骸里，藏着足以颠覆星际联盟的秘密。拾荒者凯必须在真相与沉默之间做出选择。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20backdrop%20of%20a%20lone%20astronaut%20standing%20before%20a%20colossal%20derelict%20spaceship%20in%20deep%20space%2C%20deep%20charcoal%20and%20indigo%20tones%2C%20dramatic%20orange%20rim%20light%2C%20epic%20scale%2C%20stylized%20concept%20art%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-space-01&orientation=landscape",
  },
  {
    id: "t-1",
    title: "长夜将明",
    tag: "悬疑 · 电视剧",
    rating: 8.8,
    meta: "2025 · 大陆 · 悬疑 / 犯罪",
    description:
      "一桩沉睡十二年的旧案重启，牵出整座城市不愿提起的往事。长夜尽头，真相正在慢慢浮现。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20backdrop%20of%20a%20lone%20detective%20walking%20on%20a%20rain-soaked%20city%20street%20at%20night%20toward%20glowing%20headlights%2C%20deep%20charcoal%20tones%2C%20dramatic%20orange%20lighting%2C%20moody%20noir%20atmosphere%2C%20stylized%20concept%20art%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-noir-02&orientation=landscape",
  },
  {
    id: "m-7",
    title: "机甲黎明",
    tag: "科幻 · 电影",
    rating: 8.5,
    meta: "2025 · 欧美 · 科幻 / 动作",
    description:
      "最后一台退役机甲，被一名失意飞行员重新唤醒。当新的威胁逼近，她必须再次登上驾驶舱。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20backdrop%20of%20a%20giant%20humanoid%20mecha%20standing%20over%20a%20ruined%20city%20skyline%20at%20dawn%2C%20deep%20charcoal%20tones%2C%20glowing%20orange%20accents%2C%20epic%20scale%2C%20stylized%20concept%20art%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-mecha-03&orientation=landscape",
  },
  {
    id: "m-9",
    title: "深海呼唤",
    tag: "科幻 · 电影",
    rating: 7.7,
    meta: "2024 · 欧美 · 科幻 / 悬疑",
    description:
      "深海科考队的声呐，接收到了来自一万米以下的回应。那片古老的光，似乎早已等待他们许久。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20backdrop%20of%20a%20deep%20sea%20diver%20descending%20into%20a%20dark%20glowing%20abyss%2C%20deep%20charcoal%20and%20deep%20blue%20tones%2C%20orange%20bioluminescent%20light%2C%20mysterious%20atmosphere%2C%20stylized%20concept%20art%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-ocean-04&orientation=landscape",
  },
  {
    id: "t-3",
    title: "权力的边缘",
    tag: "剧情 · 电视剧",
    rating: 9.0,
    meta: "2025 · 欧美 · 剧情 / 犯罪",
    description:
      "一场选举背后，是层层叠叠的交易、背叛与野心。年轻的幕僚试图在棋盘般的博弈中保持清醒。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20backdrop%20of%20an%20elegant%20dark%20mansion%20hall%20with%20a%20lone%20figure%20and%20warm%20chandelier%20light%2C%20deep%20charcoal%20tones%2C%20dramatic%20orange%20lighting%2C%20tense%20atmosphere%2C%20stylized%20concept%20art%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-power-05&orientation=landscape",
  },
];